// Render a verse/poem onto a canvas and download it as a shareable PNG image card.
function wrapLines(ctx, text, maxWidth) {
  const out = [];
  text.split("\n").forEach((para) => {
    if (para.trim() === "") {
      out.push("");
      return;
    }
    const words = para.split(/\s+/);
    let line = "";
    words.forEach((w) => {
      const test = line ? `${line} ${w}` : w;
      if (ctx.measureText(test).width > maxWidth && line) {
        out.push(line);
        line = w;
      } else {
        line = test;
      }
    });
    if (line) out.push(line);
  });
  return out;
}

export function downloadVerseCard({ text, attribution = "", filename = "mirrors-verse" }) {
  const W = 1080;
  const H = 1350;
  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");

  // Warm background gradient
  const g = ctx.createLinearGradient(0, 0, W, H);
  g.addColorStop(0, "#17100C");
  g.addColorStop(0.55, "#241913");
  g.addColorStop(1, "#3a2416");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, W, H);

  // Amber glow top
  const rg = ctx.createRadialGradient(W / 2, 0, 50, W / 2, 0, W);
  rg.addColorStop(0, "rgba(212,175,55,0.16)");
  rg.addColorStop(1, "rgba(212,175,55,0)");
  ctx.fillStyle = rg;
  ctx.fillRect(0, 0, W, H);

  // Border
  ctx.strokeStyle = "rgba(212,175,55,0.5)";
  ctx.lineWidth = 3;
  ctx.strokeRect(48, 48, W - 96, H - 96);

  // Quote text
  const maxWidth = W - 220;
  const fontSize = text.length > 220 ? 46 : text.length > 120 ? 56 : 66;
  ctx.font = `italic ${fontSize}px Georgia, 'Times New Roman', serif`;
  ctx.fillStyle = "#F7F1E6";
  ctx.textAlign = "center";
  const lines = wrapLines(ctx, `“${text}”`, maxWidth);
  const lineHeight = fontSize * 1.42;
  const blockHeight = lines.length * lineHeight;
  let y = H / 2 - blockHeight / 2;
  lines.forEach((ln) => {
    ctx.fillText(ln, W / 2, y);
    y += lineHeight;
  });

  // Attribution
  if (attribution) {
    ctx.font = "34px Georgia, serif";
    ctx.fillStyle = "#D4AF37";
    ctx.fillText(`— ${attribution}`, W / 2, y + 40);
  }

  // Footer brand
  ctx.font = "28px Georgia, serif";
  ctx.fillStyle = "rgba(212,175,55,0.85)";
  ctx.fillText("Mirrors of Your Soul", W / 2, H - 90);

  const url = canvas.toDataURL("image/png");
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}.png`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
